/* poostar.icon.svg.js */

"use strict";
module.exports = {
    icon: require("../common/poo.icon.svg").icon,
    toggledIcon: require("../common/star.icon.svg").icon,
};
